/* ===========================================================
   Swap the "SR" / "SAR" currency text for the new Saudi Riyal
   sign (U+20C1) in prices the theme renders itself.

   The proper fix is the shop money format
   (Settings -> Store details -> Currency formatting):
       {{amount}} <span class="pl-sar">&#x20C1;</span>
   Until that is set, this sweeps the storefront.

   Deliberately narrow: it only walks text nodes inside elements
   that look like price containers, and only rewrites a currency
   token that directly follows a number.
   =========================================================== */
(function () {
  'use strict';

  var SIGN = '⃁';
  // a number, optional space, then the currency token
  var RX = /(\d[\d.,٫٬]*)(\s*)(SAR|SR)(?![A-Za-z])/g;

  var SELECTOR = [
    '.price',
    '.money',
    '.product__price',
    '.pl-pack__price',
    '.pl-pack__was',
    '.pl-pack__unit',
    '.pl-tier__price',
    '.pl-bnpl__amt',
    '[class*="price" i]',
    '[data-price]'
  ].join(',');

  // Only the digits are isolated left-to-right. Isolating the digits AND the
  // sign together would flip the pair into English order inside an RTL page.
  function wrap(match, num, space, token) {
    return '<span class="pl-num">' + num + '</span> <span class="pl-sar">' + SIGN + '</span>';
  }

  function sweepNode(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.closest('.pl-sar')) return;

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('S') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || p.classList.contains('pl-sar')) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        return RX.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var targets = [];
    var n;
    while ((n = walker.nextNode())) targets.push(n);

    targets.forEach(function (node) {
      RX.lastIndex = 0;
      var html = node.nodeValue.replace(/[&<>]/g, function (c) {
        return c === '&' ? '&amp;' : c === '<' ? '&lt;' : '&gt;';
      }).replace(RX, wrap);
      var span = document.createElement('span');
      span.innerHTML = html;
      node.parentNode.replaceChild(span, node);
    });
  }

  function sweep(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    var list = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) sweepNode(list[i]);
    if (scope !== document && scope.matches && scope.matches(SELECTOR)) sweepNode(scope);
  }

  function boot() {
    sweep(document);

    // prices are re-rendered on variant change, cart updates and drawer opens
    var pending = null;
    var mo = new MutationObserver(function (records) {
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        records.forEach(function (r) {
          for (var i = 0; i < r.addedNodes.length; i++) sweep(r.addedNodes[i]);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
